const DESTINATIONS = {
  PROPOSAL: 'proposal',
  HOME: 'home',
  LOGIN: 'login',
};

const BANKS = {
  ALTIS: {
    code: 'altis',
    name: 'Altis',
    url: 'https://auto.altisapp.com',
    destination: DESTINATIONS.LOGIN,
  },
  BRADESCO: {
    code: '394',
    name: 'Bradesco',
    url: 'https://wwwsn.bradescofinanciamentos.com.br/finilojmobile/#/login-beta',
    destination: DESTINATIONS.LOGIN,
  },
  BV: {
    code: '655',
    name: 'BV',
    url: 'https://parceiro.bv.com.br/spa-ppar-base-dealer-veiculo/#/',
    destination: DESTINATIONS.HOME,
  },
  CARBANK: {
    code: 'carbank',
    name: 'CarBank',
    url: 'https://digital.bancovw.com.br/FrontEnd/logins',
    destination: DESTINATIONS.LOGIN,
  },
  C6: {
    code: '336',
    name: 'C6',
    url: 'https://c6auto.com.br/originacaolojista/login',
    destination: DESTINATIONS.LOGIN,
  },
  CREDITAS: {
    code: '342',
    name: 'Creditas',
    url: 'https://autofin.prod.creditas.io/',
    destination: DESTINATIONS.HOME,
  },
  DAYCOVAL: {
    code: '707',
    name: 'Daycoval',
    url: 'https://ecode.daycoval.com.br/',
    destination: DESTINATIONS.LOGIN,
  },
  FONTECRED: {
    code: 'fontecred',
    name: 'Fontecred',
    url: 'https://app.fontecred.com.br/propostas/:identifier',
    destination: DESTINATIONS.PROPOSAL,
  },
  HONDA: {
    code: 'M22',
    name: 'Honda',
    url: 'https://www3.honda.com.br/corp/ihs/portal/#/Iframe',
    destination: DESTINATIONS.HOME,
  },
  HYUNDAI: {
    code: 'M26',
    name: 'Hyundai',
    url: 'https://brpioneer.accenture.com/originacao-auto-hyundai/proposal?id=:identifier',
    destination: DESTINATIONS.PROPOSAL,
  },
  ITAU: {
    code: '341',
    name: 'Itaú',
    url: 'https://www.credlineitau.com.br/quote/:identifier',
    destination: DESTINATIONS.PROPOSAL,
  },
  KUNA: {
    code: 'kuna',
    name: 'Kuna',
    url: 'https://www.kunacapital.com/',
    destination: DESTINATIONS.LOGIN,
  },
  AUTOBANKING: {
    code: 'moneyplus',
    name: 'AutoBanking',
    url: 'https://bmpdigital.moneyp.com.br/#/bmpdigital/proposta/detalhes?codigo=:identifier',
    destination: DESTINATIONS.PROPOSAL,
  },
  PAN: {
    code: '623',
    name: 'Pan',
    url: 'https://veiculos.bancopan.com.br/propostas/detalhes/:identifier?status=credito-aprovado',
    destination: DESTINATIONS.HOME,
  },
  SAFRA: {
    code: '422',
    name: 'Safra',
    url: 'https://financeira.safra.com.br/veiculos/login',
    destination: DESTINATIONS.LOGIN,
  },
  SANTANDER: {
    code: '033',
    name: 'Santander',
    url: 'https://brpioneer.accenture.com/originacao-auto/proposal?id=:identifier',
    destination: DESTINATIONS.PROPOSAL,
  },
  VOLKSWAGEN: {
    code: 'M14',
    name: 'Volkswagen',
    url: 'https://digital.bancovw.com.br/FrontEnd/login',
    destination: DESTINATIONS.LOGIN,
  },
};

export function identify(code) {
  const bank = Object.values(BANKS).find(b => b.code === code);

  return bank ? bank.name : 'Banco desconhecido';
}

export default BANKS;
